<template>
<section :class="['card_container',status == 1 ? 'active' : '']" :style="styleCss ? styleCss : ''" >
    <span v-if="!!isActivity" class="coupon_tip">赠品</span>
    <h5 class="name_con" :style="nameSize ? 'font-size:' + nameSize : ''">{{coupontype ? (coupontype == "快车" ? "快车非拼车": coupontype) : '专车'}}·{{couponname ? couponname : '券名称'}}
        <span class="tiptip name" v-if="!couponname"><span class="arrow-left"></span>券名称</span>
    </h5>
    <p class="time_con">有效期至{{validity}}</p>
    <p class="tip_con">{{tip ? tip : '优惠券说明文字'}}<span v-if="!tip" class="tiptip"><span class="arrow-left"></span>券说明</span></p>
    <div class="price_con">
        <span class="sign">{{price ? '&yen;' : ""}}</span>
        <span class="price" :style="priceSize ? 'font-size:' + priceSize : ''">{{price}}</span>
    </div>
</section>
</template>
<script>
export default {
  name: 'CouponCard',
  componentName: 'CouponCard',
  data () {
    return {
      styleCss: `width:${this.width}px;height:${this.height}px;padding:${this.padding}`
    }
  },
  methods: {
  },
  computed: {

  },
  props: {
    couponname: String,
    coupontype: String,
    validity: String,
    price: [String, Number],
    tip: String,
    status: [Number, String],
    nameSize: String,
    priceSize: String,
    width: Number,
    height: Number,
    padding: String,
    isActivity: Boolean
  }
}
</script>

<style lang="stylus">

.card_container{
    box-sizing: border-box
    width: 286px
    height: 100px
    position: relative
    background: #FFF
    border: 0 solid #E5E5E5
    box-shadow: 0 1px 0 0 rgba(0,0,0,0.06)
    color: #333
    background: url("../images/no_active_coupon.png") no-repeat
    background-size: 100% 100%
    padding: 10px
    overflow: hidden
    .coupon_tip{
        position: absolute
        top: 4px
        left: -19px
        background-color: #fc6f53
        transform: rotate(-45deg) scaleX(0.8) scaleY(0.8)
        font-size: 12px
        color: #fff
        display: inline-block
        width: 65px
        text-align: center
        line-height: 19px
        height: 19px
    }
    .name_con{
        font-family: PingFangSC-Medium, sans-serif
        font-size: 16px
        text-align: left
        margin: 0px
        line-height: 26px;
        max-width: 200px;
    }
    .time_con{
        font-size: 12px
        font-family: PingFangSC-Regular
        margin-top: 3px
        line-height: 18px
    }
    .tip_con{
        font-size: 12px
        color: #999
        text-align: left
        position: absolute
        bottom: 12px;
        line-height: 16px;
    }
    .price_con{
        position: absolute
        top: 10px
        right: 8px
        .sign{
            font-family: PingFangSC-Semibold
            font-size: 14px
            text-align: left
        }
        .price{
            font-family: DINAlternate-Bold
            font-size: 36px
            color: #333
            display: inline-block
            margin-left: 5px
        }
    }
    .tiptip{
        position:absolute
        background-color #FC6F53
        color #fff
        padding: 2px
        font-size: 12px
        width: 40px
        text-align: center
        margin-left: 10px
        margin-top: -2px
        line-height: 20px;
        &.name{
            margin-top:0px
        }
    }
    .arrow-left {
        width:0
        height:0
        border-top:6px solid transparent
        border-bottom:6px solid transparent
        border-right:6px solid #FC6F53
        margin-left: -10px;
        margin-top: 4px;
        position: absolute;
    }

}
.active{
    background: url("../images/active_coupon.png") no-repeat
    background-size: 100% 100%
}
</style>
